module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-1-128.c08f1ce0b227036b.jpg"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-1-128.c08f1ce0b227036b.jpg",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-1-128.c08f1ce0b227036b.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-1-128.c08f1ce0b227036b.jpg"},
        
        width: 128,
        height: 85
      }